import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isSaving", "selectedOption"];
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Select } from 'foundations-components/transitional/components/Select';
import SavableFormLabel from './SavableFormLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ReasonForEscalationSelect(_ref) {
  let {
      isSaving = false,
      selectedOption = undefined
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const props = Object.assign({
    isSaving,
    selectedOption
  }, rest);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SavableFormLabel, {
      "data-test-id": "reason-for-escalation-select-label",
      isSaving: props.isSaving,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.escalations.fields.reasonForEscalation.label"
      })
    }), /*#__PURE__*/_jsx(Select, {
      "data-test-id": "reason-for-escalation-select-select",
      onChange: ({
        target: {
          value
        }
      }) => props.onSelect(value),
      options: props.options,
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.escalations.fields.reasonForEscalation.placeholder"
      }),
      value: props.selectedOption
    })]
  });
}
ReasonForEscalationSelect.propTypes = {
  isSaving: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  selectedOption: PropTypes.number
};
export default ReasonForEscalationSelect;